
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TicketCRUDFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TicketCRUD"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"read"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overwrite"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TicketStateFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TicketState"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignee_quota"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignee_as_editor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crud"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TicketCRUDFull"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TicketFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ticket"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scope_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scope_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crud"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TicketCRUDFull"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"active_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignee_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"own_docs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fully_matched_docs"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_modified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"states"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TicketStateFull"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serve_ready"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":549}};
    doc.loc.source = {"body":"fragment TicketCRUDFull on TicketCRUD {\n  create\n  read\n  update\n  delete\n  overwrite\n}\n\nfragment TicketStateFull on TicketState {\n  main_state\n  sub_state\n  assignees\n  confirmors\n  assignee_quota\n  assignee_as_editor\n  crud {\n    ...TicketCRUDFull\n  }\n}\n\nfragment TicketFull on Ticket {\n  _id\n  scope_id\n  scope_type\n  name\n  crud {\n    ...TicketCRUDFull\n  }\n  active_state\n  meta {\n    assignee_meta {\n      assignee\n      own_docs\n      fully_matched_docs\n    }\n  }\n  last_modified\n  states {\n    ...TicketStateFull\n  }\n  version\n  serve_ready\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TicketCRUDFull"] = oneQuery(doc, "TicketCRUDFull");
        
        module.exports["TicketStateFull"] = oneQuery(doc, "TicketStateFull");
        
        module.exports["TicketFull"] = oneQuery(doc, "TicketFull");
        
